export function calculatePromosCount(bankData) {
    if (!bankData?.promo)
        return 0;
    let countPromo = Object.keys(bankData.promo).length;
    if (bankData.myPreferences?.value > 0) {
        countPromo += 1;
    }
    if (bankData.salaryProject?.value > 0) {
        countPromo += 1;
    }
    return countPromo;
}
